import { useUnitLabel } from './useUnitLabel';

interface UnitProps {
  unit: string | undefined;
  value?: number | null;
}

export const Unit = ({ unit, value }: UnitProps) => {
  const label = useUnitLabel();

  return <>{label(unit, { count: value })}</>;
};
